/**
 * Track/artist text normalization shared by the streaming TrackMatcher.
 * Keep behavior aligned with electron/src/utils/TrackTextNormalize.ts
 * (local file matcher discovery + scoring).
 */

export function foldDiacritics(text: string): string {
  if (!text) return '';
  return text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Collapse dotted / spaced initialisms: V.I.C. / V.I.C / V I C → vic
 */
export function collapseInitialisms(text: string): string {
  if (!text) return '';

  let result = text;
  let previous = '';

  while (result !== previous) {
    previous = result;
    result = result.replace(/([a-z0-9])\.([a-z0-9])/gi, '$1$2');
  }

  result = result.replace(/\.+/g, '');
  result = result.replace(/\b([a-z])(?:\s+[a-z])+\b/gi, (match) =>
    match.replace(/\s+/g, ''),
  );

  return result;
}

/**
 * Canonical form for comparison: Beyoncé→beyonce, V.I.C.→vic, Snap!→snap
 */
export function normalizeForSearch(text: string): string {
  if (!text || typeof text !== 'string') return '';

  let result = foldDiacritics(text).toLowerCase().trim();
  // Music-specific char folds before stripping punctuation
  result = result.replace(/\$/g, 's'); // A$AP → asap, Ke$ha → kesha
  result = result.replace(/\s*&\s*/g, ' and ').replace(/\s+\+\s+/g, ' and ');
  // Path separators are word breaks, unlike the hyphens in Jay-Z / Hip-Hop
  // that the punctuation strip below is meant to close up.
  result = result.replace(/[_/\\|]+/g, ' ');
  result = collapseInitialisms(result);
  result = result.replace(/[^a-z0-9\s]/g, '');
  result = result.replace(/\s+/g, ' ').trim();
  result = collapseInitialisms(result);
  return result.replace(/\s+/g, ' ').trim();
}
